<script>
import appConfig from "@/app.config";
import {
  layoutMethods,
  erpUsersMethods,
  erpUsersComputed,
  erpUserRolesMethods,
  erpUserRolesComputed,
} from "@/state/helpers";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { getModuleAccess } from '@/router/helper.js'

export default {
  page: {
    title: "User Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      user: {
        name: "",
        email: "",
        position: "",
        role: {
          id: "",
          name: ""
        },
        department: "",
        lineManager: "",
        photo: "",
      },
      searchValue: {
        searchField: null,
        search: "",
        status: null,
        dateRange: null,
        payment_method: null,
        sort: "id",
        orderDesc: true,
      },
      params: {},
      userProfileImg: "@/assets/images/users/avatar-1.jpg",
      roleOptions: [
        {
          text: "",
          value: "",
        },
      ],
      usersModule: {
				access: {
          update: true
				}
			}
    };
  },
  mounted: async function () {
    this.userId = this.$route.params.id;
    this.changeTitle({ title: "User Details" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Users", to: { name: "Users" } },
        { text: this.$route.params.id, to: { name: "User ID" } },
      ],
    });

    await this.getRoles();
    await this.getUserById();

    this.role = this.user.role.id == null ? 'Select Role' : this.user.role;

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'User Management', 'Users')
    .then((access) => this.usersModule.access = access);

  },
  computed: {
    ...erpUsersComputed,
    ...erpUserRolesComputed,
  },
  components: {
    Multiselect,
  },
  methods: {
    ...layoutMethods,
    ...erpUsersMethods,
    ...erpUserRolesMethods,
    /*
        Created by: Jero Balucas
        Created at: Dec 20, 2022
        Description: getTopupLogById will fetch the topup transaction details by transaction id
        Params: this.transactionId
    */
    getUserById: async function () {
      await this.readUser({
        body: { userId: this.$route.params.id },
      })
        .then(() => {
          this.user.name = this.erpUsersList[0].name;
          this.user.email = this.erpUsersList[0].email;
          this.user.position = this.erpUsersList[0].position;
          this.user.role = {
            id: this.erpUsersList[0].roleId != null
              ? this.erpUsersList[0].roleId
              : null,
            name: this.erpUsersList[0].roleName != null
              ? this.erpUsersList[0].roleName
              : "Select Role",
          };
          this.user.department = this.erpUsersList[0].department;
          this.user.lineManager = this.erpUsersList[0].managerEmail;
          this.user.photo = this.erpUsersList[0].photo;

          //   console.log(this.user);
        })
        .catch(function (error) {
          Swal.fire("Failed! ", error, "warning");
          console.log(error);
        });
    },
    getRoles: async function () {
      var roles = [];
      await this.getAllRoles();
      this.rolesList.map(function (role) {
        roles.push({
          name: role.name,
          id: role.id,
        });
      });
      this.roleOptions = roles;
    },
    updateUser: async function () {
      // console.log(this.user.role);
      await this.manageUser({
        action: "update",
        body: {
          userId: this.$route.params.id,
          roleId:
            this.user.role != null ? JSON.stringify(this.user.role.id) : null,
          updatedBy: JSON.parse(localStorage.getItem("userData")).email, // Replace this with actual name of the user
        },
      }).then(() => {
        Swal.fire("User Updated Successfully!", "", "success");
      }).catch(function (error) {
        Swal.fire("Failed! ", error, "warning");
        console.log(error);
      });
    },
    customLabel({ name = "" }) {
      return `${name}`;
    },
    setPhoto(photo) {
      return photo != "" || photo != null ? `data:image/jpeg;base64,${photo}` : this.userProfileImg
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-3">
        <!-- User Details card -->
        <div class="card">
          <div class="card-body">
            <div class="avatar-xl mx-auto mb-3">
              <img :src="setPhoto(user.photo)" alt="" @error="(e) =>
                  (e.target.src = require('@/assets/images/user_icon.png'))
              " class="rounded-circle img-thumbnail fix-img" />
            </div>
            <ul class="list-unstyled mb-0 mt-4">
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-user-circle"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-2 font-size-13 fw-semibold">Name</p>
                    <h5 class="mb-3 font-size-14 fw-normal">
                      {{ user.name }}
                    </h5>
                  </div>
                </div>
              </li>
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-mobile-alt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-2 font-size-13 fw-semibold">Email</p>
                    <h5 class="mb-0 font-size-14 fw-normal">
                      {{ user.email }}
                    </h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- end User Details card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
          <div class="col-lg-12">
            <!-- Other Details card -->
            <div class="card" style="max-width: 620px">
              <div class="card-body" style="max-width: 620px">
                <div class="d-flex mb-3" v-if="!usersModule.access.update">
                  <div class="flex-grow-1 my-auto">
                    <label class="form-label medium fw-bold text-danger">Note: Your access is limited. You cannot update a User.</label>
                  </div>
                </div>
                <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                  <div class="flex-grow-1 my-auto">
                    <span class="align-middle fw-semibold">Other Details</span>
                  </div>
                </div>
                <div class="row">
                  <form>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="row mb-3">
                          <label class="font-size-14 fw-semibold">Position:</label>
                          <b-form-input type="text" class="font-size-13 fw-bold custom-input" v-model="user.position"
                            disabled />
                        </div>
                        <div class="row mb-3">
                          <label class="font-size-14 fw-semibold">Role:</label>
                          <multiselect v-model="user.role" :options="roleOptions" :searchable="false"
                            :close-on-select="true" :show-labels="true" :hide-selected="false"
                            :custom-label="customLabel" track-by="name" placeholder="Select Role" style="width: 97%;">
                          </multiselect>
                        </div>
                        <div class="row mb-3">
                          <label class="font-size-14 fw-semibold">Department:</label>
                          <b-form-input type="text" class="font-size-13 fw-bold custom-input" v-model="user.department"
                            disabled />
                        </div>
                        <div class="row mb-3">
                          <label class="font-size-14 fw-semibold">Line Manager:</label>
                          <b-form-input type="text" class="font-size-13 fw-bold custom-input" v-model="user.lineManager"
                            disabled />
                        </div>
                      </div>

                      <div class="text-end mt-5">
                        <b-button :disabled="!usersModule.access.update" type="button" variant="primary" class="w-sm" @click="updateUser()">Submit</b-button>
                        <b-button variant="light" class="w-sm ms-2" @click="$router.back()">Close</b-button>
                      </div>
                    </div>
                    <!-- hidden -->
                  </form>
                </div>
              </div>
            </div>
            <!-- end Transaction Details card -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid~.invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 14px;
}

.multiselect__placeholder {
  font-size: 14px;
}

.multiselect__single {
  padding-left: 0px;
}

.custom-input {
  width: 97%;
  margin-left: 10px;
  height: 39px;
}
</style>
